export const GET_EVALUATIONS = "GET_EVALUATIONS"
export const GET_EVALUATIONS_FAIL = "GET_EVALUATIONS_FAIL"
export const GET_EVALUATIONS_SUCCESS = "GET_EVALUATIONS_SUCCESS"

export const ADD_NEW_EVALUATION = "ADD_NEW_EVALUATION"
export const ADD_EVALUATION_SUCCESS = "ADD_EVALUATION_SUCCESS"
export const ADD_EVALUATION_FAIL = "ADD_EVALUATION_FAIL"

export const UPDATE_EVALUATION = "UPDATE_EVALUATION"
export const UPDATE_EVALUATION_SUCCESS = "UPDATE_EVALUATION_SUCCESS"
export const UPDATE_EVALUATION_FAIL = "UPDATE_EVALUATION_FAIL"

export const DELETE_EVALUATION = "DELETE_EVALUATION"
export const DELETE_EVALUATION_SUCCESS = "DELETE_EVALUATION_SUCCESS"
export const DELETE_EVALUATION_FAIL = "DELETE_EVALUATION_FAIL"


// Average par évaluation
export const GET_AVERAGE_BY_EVALUATION = "GET_AVERAGE_BY_EVALUATION";
export const GET_AVERAGE_BY_EVALUATION_SUCCESS = "GET_AVERAGE_BY_EVALUATION_SUCCESS";
export const GET_AVERAGE_BY_EVALUATION_FAIL = "GET_AVERAGE_BY_EVALUATION_FAIL";




